import { BestOf2025ResourceCardWrapper } from 'app/components/BestOf2025/styled';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import { BREAKPOINTS } from 'styles/media';

export const ResourcesFilterBarWrapper = styled.div`
  min-width: var(--resource-sidebar-width);
  max-width: var(--resource-sidebar-width);
  height: calc(100svh - var(--navbar-height) - var(--draft-banner-height, 0px));

  overflow-y: auto;

  position: sticky;
  top: calc(var(--navbar-height) + var(--draft-banner-height, 0px));
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 48px;

  padding: 40px 20px;

  background: rgba(247, 247, 247, 0.5);
  box-shadow: 0 6px 24px 0 rgba(0, 0, 0, 0.1);
`;

export const ResourcesFilterBarContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ResourcesFilterBarInformationWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;

  ${BREAKPOINTS.tablet} {
    padding: 0px 16px;
  }
`;

export const ResourcesFilterBarInformationContainer = styled.div`
  display: flex;
  flex-direction: column;

  & > :not(:last-child) {
    margin-bottom: 8px;
  }
`;

export const ResourcesFilterBarTitle = styled.h3`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;

  font-weight: 400;
  font-size: 32px;
  line-height: normal;
  color: var(--color-text);

  cursor: pointer;

  ${BREAKPOINTS.mobile} {
    font-size: 24px;
  }
`;

export const ResourcesFilterBarDescription = styled.p`
  font-weight: 400;
  font-size: 18px;
  line-height: normal;
  color: rgba(23, 28, 51, 0.5);

  ${BREAKPOINTS.mobile} {
    font-size: 14px;
  }
`;

export const ResourcesFilterBarSectionContainer = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;

  & > :not(:last-child) {
    margin-bottom: 16px;
  }
`;

export const ResourcesFilterBarBottomContainer = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 16px;

  opacity: 0.5;
`;

export const ResourcesFilterBarSectionTitle = styled.span`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: var(--color-text);
`;

export const ResourcesFilterBarCurrentFiltersContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  gap: 8px;
`;

export const ResourcesFilterBarQuickFiltersContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 33%);
  grid-gap: 8px;
`;

//BEST OF 2025
export const ResourcesFilterBarBestOf2025Wrapper = styled.div`
  width: 100%;
  max-width: 1440px;
  min-height: 100svh;

  display: flex;
  flex-direction: column;
  gap: 24px;

  margin: 0 auto;

  padding: 36px 40px;

  ${BREAKPOINTS.tablet} {
    padding: 16px 20px 36px 20px;
  }

  ${BREAKPOINTS.mobile} {
    ${BestOf2025ResourceCardWrapper} {
      justify-self: center;
    }
  }
`;

export const ResourcesFilterBarBestOf2025HeroWrapper = styled.div`
  width: 100%;
  min-height: 152px;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  ${BREAKPOINTS.tablet} {
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 24px;
  }
`;

export const ResourcesFilterBarBestOf2025Title = styled(motion.h3).attrs({
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -20 },
  transition: { duration: 0.2 },
})`
  font-weight: 400;
  font-size: 32px;
  line-height: normal;

  color: var(--color-text);

  ${BREAKPOINTS.tablet} {
    font-size: 24px;
    text-align: center;
    align-self: center;
  }
`;

export const ResourcesFilterBarBestOf2025Subtitle = styled.h4`
  font-weight: 400;
  font-size: 24px;
  line-height: normal;

  color: var(--color-text);

  ${BREAKPOINTS.tablet} {
    font-size: 18px;
    text-align: center;
    align-self: center;
  }
`;

// BEST OF 2025 HERO STATISTICS
export const ResourcesFilterBarBestOf2025HeroStatisticsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  ${BREAKPOINTS.tablet} {
    flex-wrap: wrap;
    justify-content: center;
  }
`;

export const ResourcesFilterBarBestOf2025HeroStatisticsItem = styled.div`
  min-width: 161px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const ResourcesFilterBarBestOf2025HeroStatisticsItemCounter = styled(motion.h2).attrs({
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -20 },
  transition: { duration: 0.2 },
})`
  font-weight: 400;
  font-size: 38px;
  line-height: 42px;
  text-align: center;

  color: var(--color-text);
`;

export const ResourcesFilterBarBestOf2025HeroStatisticsItemText = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  text-align: center;

  color: rgba(23, 28, 51, 0.5);
`;
